import { TableCell, styled } from "@mui/material";
import { serviceTableStyle as commonTextStyle } from "../../invoiceGeneration/serviceInvoice/ServiceTableStyles";

export const HeadCell = styled(TableCell)({
  ...commonTextStyle.tableHead,
  fontWeight: 500,
});

export const HeadItemCell = styled(HeadCell)({
  width: "50%",
  borderRight: "3px solid black",
  textAlign: "center",
});

export const HeadHSNCell = styled(HeadCell)({
  width: "25%",
});

export const HeadPreTaxCell = styled(HeadCell)({
  width: "25%",
  borderLeft: "3px solid black",
});

export const ServiceCell = styled(TableCell)({
  ...commonTextStyle.serviceData,
  borderRight: "3px solid black",
  lineHeight: 2,
});

export const TaxLabelCell = styled(TableCell)({
  fontStyle: "italic",
  fontWeight: 500,
  borderRight: "3px solid black",
  borderLeft: "3px solid black",
  verticalAlign: "top",
  paddingLeft: "5px",
});

export const TaxValueCell = styled(TableCell)({
  verticalAlign: "top",
  paddingLeft: "5px",
});

export const AmountInWordsCell = styled(TableCell)({
  ...commonTextStyle.div,
  paddingLeft: "3px",
});

export const OutstandingLeftCell = styled(TableCell)({
  ...commonTextStyle.div,
  paddingLeft: "3px",
  borderRight: "3px solid black",
});

export const OutstandingRightCell = styled(TableCell)({
  ...commonTextStyle.div,
  paddingLeft: "3px",
});

export const LabelSpan = styled("span")({
  fontWeight: 500,
  fontSize: "11px",
  fontFamily: "Inter",
});

export const DivText = styled("div")({
  fontSize: "11px",
  fontFamily: "Inter",
  lineHeight: 2,
});

export const TotalText = styled(DivText)({
  marginTop: "20px",
  fontWeight: 600,
  borderTop: "3px solid black",
});
